<template>
  <div>
    <pageTitle :extinfo="extinfo"></pageTitle>
    <div class="works-banner" :style="{'height': screenWdith}">
      <div class="works-banner-page">{{ bgIndex }}/{{ imageList.length }}</div>
      <van-swipe class="wd-swiper-box" :style="{'height': screenWdith}" @change="onChange">
        <van-swipe-item :key="index + 1" v-for="(item, index) in imageList">
          <div class="wd-swiper-image-box" @click="proImag(item[0])">
            <img class="swipe-img" :src="item[0]+'?x-oss-process=image/resize,l_600'" :style="{'height':item[2], 'width': item[1]}" alt=""/>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="wd-box">
      <div class="wd-box-content">
        <div class="wd-box-title">{{ workDetail.title }}</div>
        <!-- <div class="wd-box-desc">{{ workDetail.user?.nickname }}作品</div> -->
        <div class="wd-box-detail">
          <div class="wd-box-item">
            作品尺寸：
            <template v-if="workDetail.worksWidth && workDetail.worksHeight">
              {{ workDetail.worksWidth }}cm x {{ workDetail.worksHeight }}cm
            </template>
            <template v-else>--</template>
          </div>
          <div class="wd-box-item box-right">
            创作时间：
            <template v-if="workDetail.madeDate">
              {{ workDetail.madeDate }}
            </template>
            <template v-else>--</template>
          </div>
        </div>
        <div class="wd-box-detail">
          <div class="wd-box-item">
            作品类型：
            <template v-if="workDetail.typeName">
              {{ workDetail.typeName }}
            </template>
            <template v-else>--</template>
          </div>
          <div class="wd-box-item box-right">
            作品材质：
            <template v-if="workDetail.materialName">
              {{ workDetail.materialName }}
            </template>
            <template v-else>--</template>
          </div>
        </div>
        <div class="wd-box-detail">
          <div class="wd-box-item">
            是否装裱：
            <template v-if="workDetail.mount == 1 || workDetail.mount === 0">
              {{ workDetail.mount == 1 ? '是' : '否' }}
            </template>
            <template v-else>--</template>
          </div>
        </div>
        <div class="wd-box-user" @click="toUser" v-if="!jump">
          <van-image style="pointer-events:none;" class="user-bg" :src="require('@/assets/bg_ysj.png')" fit="cover " />
          <div class="wd-user-info" style="pointer-events:none;">
            <div class="wd-user-left">
              <van-image class="wd-user-head" :src="workDetail.user?.avatar" round fit="cover" height="40" width="40" />
              <div class="wd-user-name">{{ workDetail.user?.nickname }}</div>
            </div>
            <div class="wd-user-right">
              <div class="wd-use-page">进入主页</div>
          </div>
          </div>
        </div>
      </div>
      <div class="wd-box-brief">
        <div class="section-title">
          <div class="left-line"></div>
          作品介绍
        </div>
          <div class="wd-box-brief-content" v-if="workDetail.brief">{{ workDetail.brief }}</div>
          <div class="wd-box-brief-content content-empty" v-else>无</div>
      <commen-list :commentList="commentList" :likeTotal="likeTotal" :commentTotal="commentTotal"></commen-list>
      </div>
    </div>
    <common-ct :likeCount="workDetail.likeCount" :commentCount="commentTotal" :extinfo="extinfo" @share="share" @common="common"
      @like="like"></common-ct>
    <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
  </div>
</template>
<script>
import { getWorksDetailById } from '@/api/artist'
import { queryCommentLikeTotal, queryCommentList } from '@/api/artinfo'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
import commonCt from '@/components/commonCt/commonCt.vue'
import commenList from '@/components/commenList/commenList.vue'
import { queryShart } from '@/api/user'
import { wexinShare, changeTitleClick } from '@/utils/utils'
import { Swipe, SwipeItem } from 'vant'
export default {
  name: 'workDetail',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    pageTitle,
    pageFoot,
    commonCt,
    commenList
  },
  data () {
    return {
      id: 0,
      bgIndex: 1,
      workDetail: {},
      imageList: [],
      showImageList: [],
      // 评论列表
      commentList: [],
      commentTotal: 0,
      likeTotal: 0, // 点赞数
      screenWdith: document.body.clientWidth,
      isSuspension: false,
      jump: 0,
      extinfo: 'yslt://?name=worksTagDetailNew&'
    }
  },
  async created () {
    this.getA()
    changeTitleClick('作品详情')
    await this.getWorksDetailById()
    await this.getCommonList()
    await this.queryCommentLikeTotal()
    this.weixin()
    const jump = localStorage.getItem('__jump')
    if (jump === 1) {
      this.jump = jump
      localStorage.removeItem('__jump')
    }
    this.extinfo = this.extinfo + `id=${this.id}`
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    onChange (index) {
      this.bgIndex = index + 1
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    // 获取作品详情
    async getWorksDetailById () {
      try {
        const res = await getWorksDetailById(this.id)
        this.workDetail = res.result
        this.workDetail.worksWidth = Math.round(this.workDetail.worksWidth)
        this.workDetail.worksHeight = Math.round(this.workDetail.worksHeight)
        this.packageWorksList()
      } catch (error) {
        console.log('获取作品详情失败', error)
      }
    },
    // 获取评论列表
    async getCommonList () {
      try {
        const res = await queryCommentList({
          topicId: this.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        this.commentList = res.result.records
        this.commentTotal = res.result.total
      } catch (error) {
        console.log('评论数据列表失败', error)
      }
    },
    // 获取评论点赞
    async queryCommentLikeTotal () {
      try {
        const res = await queryCommentLikeTotal({
          topicId: this.id
        })
        this.likeTotal = res.result.likeCount
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    toUser () {
      const url = `http://room.yslt.art/SharePageTest?onSharePage=0&userId=${this.workDetail.user.id}`
      window.location.href = url
    },
    packageWorksList () {
      const that = this
      that.imageList = []
      that.showImageList = []
      const imgTemp = that.workDetail.coverUrl.split(',')
      imgTemp.forEach(imgUrl => {
        const img = new Image()
        img.src = imgUrl
        img.onload = function () {
          let heigt = 300
          let width = 300
          if (img.height > img.width) {
            width = Math.round(300 / img.height * img.width)
          } else {
            heigt = Math.round(300 / img.width * img.height)
          }
          const item = [imgUrl, width + 'px', heigt + 'px']
          that.showImageList.push(imgUrl)
          that.imageList.push(item)
        }
      })
    },
    // 预览图片
    proImag (img) {
      let position = 0
      this.showImageList.forEach((item, index) => {
        if (item === img) {
          position = index
        }
      })
      this.ImagePreview({ images: this.showImageList, startPosition: position })
    },
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.id = obj.id
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log(res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.workDetail.title,
          desc: this.workDetail.brief,
          link: `http://room.yslt.art/SharePageTest/?id=${this.id}#/workDetail`,
          imgUrl: this.workDetail.coverUrl
        })
      })
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    },
    share () {
      // this.open()
    },
    common () {
      // this.open()
    },
    like () {
      // this.open()
    }
  }
}
</script>
<style lang="scss" scoped>
.works-banner {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  position: relative;
  .works-banner-page {
    background-color: rgba(0, 0, 0, 0.68);
    height: 20px;
    width: 40px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 999;
    top: 13px;
    right: 13px;
    color: #fff;
    font-size: 13px;
    font-weight: 400;
  }
  .wd-swiper-box {
    width: 100%;
    background-color: #f4f4f4;
    .wd-swiper-image-box {
      margin: 37px;
      height: 300px;
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      .swipe-img {
        will-change: transform;
        margin: 0 auto;
        border: 1px solid #fff;
        box-shadow: 10px 10px 30px rgba(91, 93, 98, 0.35);
        pointer-events:none;
      }
    }
  }
}
  .wd-box {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding-bottom: 80px;
    .wd-box-content {
      padding: 25px 20px 20px 20px;
      border-bottom: 1px solid #EEE;
      .wd-box-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
      }
      .wd-box-desc {
        color: #A26F43;
        font-size: 14px;
        margin-bottom: 15px;
      }
      .wd-box-detail {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        line-height: 1.8;
        .wd-box-item {
          flex: 3;
          font-size: 13px;
          color: #666;
          text-align: left;
        }
        .box-right {
          flex: 2;
        }
      }
        .wd-box-user {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
          margin-top: 15px;
          position: relative;
          .wd-user-info {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 12px;
            .wd-user-left {
              flex: 1;
              display: flex;
              align-items: center;
              .wd-user-name {
                font-size: 16px;
                color: #333;
                font-weight: bold;
                margin-left: 8px;
              }
            }
            .wd-user-right {
              .wd-use-page {
                background-color: #fff;
                border: 1px solid #C4946B;
                color: #C4946B;
                font-size: 12px;
                padding: 4px 10px;
              }
            }
          }
        }
    }
    .wd-box-brief {
      padding: 0 20px;
      .section-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        padding: 30px 0 16px 0;
        .more {
         color: #999999;
         font-size: 13px;
         font-weight: 400;
         float: right;
         margin-top: 4px;
         img {
          height: 10px;
          width: auto;
          margin-left: 8px;
         }
        }
    }
      .wd-box-brief-content {
        color: #333;
        font-size: 14px;
        line-height: 1.8;
        font-weight: 400;
        white-space: pre-line;
      }
      .content-empty {
        color: #999;
      }
    }
  }
</style>
